// extracted by mini-css-extract-plugin
module.exports = {"section":"BlocSeo_section___he6l","row":"BlocSeo_row__jR_b8","col":"BlocSeo_col__f7MYO"};